<template>
    <b-container fluid>
        <b-overlay :show="loading"
                   rounded="sm"
                   opacity="0.3"
                   bg-color="#efefef">
            <b-card>
                <template #header>
                    <div class="d-flex justify-content-between">
                        <h5>대상 기업 조회</h5>

                        <b-button @click="searchHistory">
                            대상 기업 검색
                        </b-button>
                    </div>
                </template>
                <b-row>
                    <b-col cols="6">
                        project_code
                        <div>
                            <b-form-input v-model="globalReportOpt.project_code"/>
                        </div>
                    </b-col>
                    <b-col cols="3">
                        Mode
                        <div>
                            <b-form-select v-model="globalReportOpt.report_mode"
                                           :options="[
                                               { value: null, text: '-- 미선택 --'},
                                                { value: 'DOC', text: '서면 보고서'},
                                                { value: 'OSIS', text: '실사 보고서'},
                                            ]"
                            />
                        </div>
                    </b-col>
                    <b-col cols="3">
                        확정여부
                        <div>
                            <b-form-select v-model="globalReportOpt.confirmed"
                                           :options="[
                                               { value: null, text: '-- 미선택 --'},
                                                { value: 1, text: '확정'},
                                                { value: 0, text: '미확정'},
                                            ]"
                            />
                        </div>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="mt-4">
                <template #header>
                    <div class="d-flex justify-content-between">
                        <h5>결과보고서 확정 및 배포 </h5>
                    </div>
                </template>

                <b-row class="mb-2">
                    <b-col cols="12" lg="2">
                        진행률 ({{ total_processed_count }} / {{ fixed_selected_num }} )
                        <div>
                            <b-progress :value="total_processed_count" :max="fixed_selected_num" height="30px">
                                <b-progress-bar :value="total_processed_count" variant="success">
                                    {{ progressPercent }}%
                                </b-progress-bar>
                            </b-progress>
                        </div>
                    </b-col>
                    <b-col cols="12" lg="5">
                        선택
                        <div>
                            <b-btn-group>
                                <b-btn variant="info"
                                       class="f-95"
                                       @click="selectLatestReport"
                                >
                                    최신 결과보고서
                                </b-btn>
                                <b-btn class="f-95"
                                       variant="dark"
                                       @click="selectConfirmedReport"
                                >
                                    확정 결과보고서
                                </b-btn>
                                <b-btn class="f-95"
                                       variant="secondary"
                                       @click="unselectAllReports"
                                >
                                    모두 선택해제
                                </b-btn>
                            </b-btn-group>
                        </div>
                    </b-col>
                    <b-col cols="12" lg="4">
                        결과보고서 핸들링
                        <div class="d-flex">
                            <b-button variant="secondary"
                                      class="mr-2"
                                      @click="downloadReport"
                            >
                                다운로드
                            </b-button>
                            <b-button variant="primary"
                                      class="mr-2"
                                      @click="handlingReport('confirm')"
                            >
                                확정
                            </b-button>
                            <b-button variant="warning"
                                      class="mr-2"
                                      @click="handlingReport('cancel')"
                            >
                                확정 취소
                            </b-button>
                            <b-button variant="danger"
                                      @click="handlingReport('delete')"
                            >
                                삭제
                            </b-button>
                        </div>
                       

                    </b-col>
                    <b-col cols="12" lg="4">
                        결과보고서 배포 언어 설정 및 배포
                        <div class="d-flex">
                            <dropdown-language :lang="globalReportOpt.submit_lang" :disabled="loading"
                                               @updateLang="(lang) => updateLang(lang, 'submit_lang')"
                            />
                            <b-button class="ml-2" variant="primary"
                                      @click="submitReport"
                            >
                                선택한 보고서 배포
                            </b-button>
                            
                        </div>
                        
                    </b-col>
                    <b-col cols="12" lg="2">
                        메일 전송 여부
                        <b-form-checkbox v-model="globalReportOpt.is_send_release_mail" size="lg" name="check-button" switch
                                         :disabled="loading"
                        />
                    </b-col>
                </b-row>
            </b-card>
            <b-row class="mb-4 mt-4">
                <b-col cols="9">
                    <h5>일괄 처리 실패 기업</h5>
                    <div>
                        {{ !fail_company_list.length ? '없음' : fail_company_list }}
                    </div>
                </b-col>
                <b-col cols="3">
                    <div class="d-flex justify-content-end align-items-end">
                        <b-button class="mr-2" @click="expandAllCompanies">
                            모두 열기
                        </b-button>
                        <b-button @click="collapseAllCompanies">
                            모두 접기
                        </b-button>
                    </div>
                </b-col>

            </b-row>

            <b-row>
                <b-col cols="12">
                    <div class="virtual-table-wrapper">
                        <div class="header-container">
                            <table class="table b-table table-hover">
                                <thead class="thead-light">
                                <tr>
                                    <th v-for="(field, index) in columns"
                                        :key="field.key"
                                        :style="index === columns.length - 1 ? getLastThStyle(field) : getColumnStyle(field)"
                                        :class="getThClass(field)"
                                    >
                                        <template>
                                            {{ $t(field.label) }}
                                        </template>
                                    </th>
                                </tr>
                                </thead>
                            </table>
                        </div>

                        <div v-if="virtualScrollItems.length === 0" class="empty-container">
                            <b-spinner v-if="loading" class="mr-1" small/>
                            <template v-if="!loading">
                                <h6 class="font-italic mb-0">{{ $t('검색된 프로젝트가 없습니다.') }}</h6>
                            </template>
                        </div>

                        <div v-else ref="bodyScrollContainer" class="body-scroll-container">
                            <RecycleScroller
                                v-slot="{ item }"
                                :items="virtualScrollItems"
                                :item-size="48.6"
                                key-field="uniqueKey"
                            >
                                <table class="body-table">
                                    <tbody>
                                    <tr class="body-row"
                                        :class="{ 
                                          'company-row': item.type === 'company',
                                          'history-row': item.type === 'history',
                                          'expandable': item.type === 'company' && item.hasHistory
                                        }"
                                    >

                                        <!-- Company Row -->
                                        <template v-if="item.type === 'company'">
                                            <td v-for="field in columns"
                                                :key="field.key"
                                                :style="getColumnStyle(field)"
                                                :class="getTdClass(field)"
                                            >
                                                <template v-if="field.key === 'selected'">
                                                    <b-button class="m-0 p-0" variant="icon" size="sm"
                                                              @click="item.type === 'company' && item.hasHistory && toggleExpand(item.company_id)"
                                                    >
                                                        <fa :icon="['fas', expandedItems.has(item.company_id) ? 'chevron-down' : 'chevron-right']"/>
                                                    </b-button>
                                                </template>
                                                <template v-else-if="field.key === 'company_id'">
                                                    <div class="d-flex">
                                                        <div>
                                                            <b-badge>{{ item.company_id }}</b-badge>
                                                        </div>
                                                        <div v-if="report_target_company_id == item.company_id" class="ml-2 d-flex align-items-center">
                                                            <b-spinner class="mr-1" variant="warning" small/>
                                                            <div>생성중</div>
                                                        </div>
                                                        <div v-else-if="map_api_result[item.company_id] === true"
                                                             class="ml-2">
                                                            <b-badge variant="success" class="mr-1">완료</b-badge>
                                                        </div>
                                                        <div v-else-if="map_api_result[item.company_id] === false"
                                                             class="ml-2">
                                                            <b-badge variant="warning" class="mr-1">실패</b-badge>
                                                        </div>
                                                    </div>
                                                    
                                                </template>
                                                <template v-else-if="field.key === 'company_name'">
                                                    {{ item[field.key] }}
                                                </template>
                                                <template v-else-if="field.key === 'time_stamp'">
                                                    <div>
                                                        개수: {{ item.historyCount }}
                                                    </div>
                                                </template>
                                                <template v-else-if="field.key === 'is_send_mail'">
                                                    <b-button size="sm" @click="unselectRadio(item)">선택해제</b-button>
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </td>
                                        </template>

                                        <!-- History Row -->
                                        <template v-else-if="item.type === 'history'">
                                            <td v-for="field in columns"
                                                :key="field.key"
                                                :style="getColumnStyle(field)"
                                                :class="[getTdClass(field), 'history-cell']"
                                            >
                                                <template v-if="field.key === 'selected'">
                                                    <b-form-radio
                                                        v-model="selectedRadios[item.company_id]"
                                                        :name="`company_${item.company_id}`"
                                                        :value="item.id.toString()"
                                                    ></b-form-radio>
                                                </template>
                                                <template v-else-if="field.key === 'report_name'">
                                                    <b-link @click="viewReport(item)">
                                                        {{ item.report_name }}
                                                    </b-link>
                                                </template>
                                                <template v-else-if="field.key === 'time_stamp'">
                                                    {{ formatTime(item?.time_stamp) || '-' }}
                                                </template>
                                                <template v-else-if="field.key === 'confirmed'">
                                                    <b-badge v-if="item[field.key]" variant="primary">확정</b-badge>
                                                    <b-badge v-else variant="warning">미확정</b-badge>
                                                </template>
                                                <template v-else-if="field.key === 'is_send_mail'">
                                                    <b-badge v-if="item[field.key]" variant="primary">배포</b-badge>
                                                    <b-badge v-else variant="dark">미배포</b-badge>
                                                </template>
                                                <template v-else>
                                                    {{ item[field.key] || '-' }}
                                                </template>
                                            </td>
                                        </template>
                                    </tr>
                                    </tbody>
                                </table>
                            </RecycleScroller>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-overlay>

        <!-- 다운로드 설정 모달 -->
        <b-modal
            id="download-setting-modal"
            ref="downloadSettingModal"
            size="lg"
            modal-class="default-modal"
            :no-close-on-backdrop="isDownloading"
            :no-close-on-esc="isDownloading"
            :hide-header-close="isDownloading"
            @hidden="onDownloadModalHidden"
        >
            <template #modal-title>
                <fa icon="download" class="text-primary mr-2"></fa>
                결과보고서 다운로드 설정
            </template>
            
            <!-- 다운로드 진행 중 -->
            <div v-if="isDownloading" class="text-center py-4">
                <div class="mb-3">
                    <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                </div>
                <h5 class="text-primary mb-2">다운로드 준비 중...</h5>
                <p class="text-muted mb-2">{{ downloadProgress.text }}</p>
                <b-progress :max="downloadProgress.total" height="24px" class="mt-3">
                    <b-progress-bar :value="downloadProgress.current" variant="success">
                        {{ downloadProgress.current }} / {{ downloadProgress.total }}
                    </b-progress-bar>
                </b-progress>
                <div class="mt-3">
                    <small class="text-muted">
                        <fa icon="info-circle" class="mr-1"></fa>
                        파일 개수에 따라 시간이 소요될 수 있습니다.
                    </small>
                </div>
            </div>
            
            <!-- 다운로드 설정 폼 -->
            <div v-else>
                <div class="mb-4">
                    <h6 class="mb-3">
                        <fa icon="file-alt" class="text-info mr-2"></fa>
                        선택된 보고서: {{ Object.keys(selectedRadios).length }}개
                    </h6>
                </div>
                
                <div class="bg-light rounded p-3 mb-3">
                    <b-form-checkbox v-model="is_customize_name" switch size="lg">
                        <strong>파일명 커스터마이징</strong>
                    </b-form-checkbox>
                    <small class="text-muted d-block mt-1">
                        활성화하면 파일명을 직접 설정할 수 있습니다. 비활성화하면 원본 파일명을 사용합니다.
                    </small>
                </div>
                
                <div v-if="is_customize_name" class="border rounded p-3">
                    <b-form-group label="파일명 패턴" label-class="font-weight-bold">
                        <b-form-input 
                            v-model="customized_name" 
                            placeholder="{vendor_code}_{company_name}_{current_year}"
                        />
                    </b-form-group>
                    
                    <div class="alert alert-info mb-0">
                        <strong>사용 가능한 변수:</strong>
                        <ul class="mb-0 mt-2">
                            <li><code>{vendor_code}</code> - 벤더 코드</li>
                            <li><code>{company_name}</code> - 회사명</li>
                            <li><code>{project_code}</code> - 프로젝트 코드</li>
                            <li><code>{report_mode}</code> - 평가유형 (DOC/OSIS)</li>
                            <li><code>{current_year}</code> - 현재 연도</li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <template #modal-footer>
                <b-button 
                    variant="secondary" 
                    :disabled="isDownloading"
                    @click="closeDownloadSettingModal"
                >
                    닫기
                </b-button>
                <b-button 
                    v-if="isDownloading"
                    variant="danger" 
                    @click="cancelDownload"
                >
                    <fa icon="times" class="mr-1"></fa>
                    취소
                </b-button>
                <b-button 
                    v-else
                    variant="primary" 
                    @click="startDownloadReports"
                >
                    <fa icon="download" class="mr-1"></fa>
                    다운로드 시작
                </b-button>
            </template>
        </b-modal>
        
    </b-container>
</template>

<script>
import dropdownLanguage from '@shared/components/utils/dropdown-language.vue';
import dayjs from 'dayjs';
import axios from 'axios';
import {waitTime} from '@shared/utils/common';
import {zipSync} from 'fflate';

export default {
    name: 'ReportBulkGenerator',
    props: {},
    components: {
        dropdownLanguage
    },
    data() {
        return {
            expandedItems: new Map(),
            updateTimer: null,
            processedData: [],
            virtualScrollItems: [],
            virtualScrollItemsCache: null,
            cacheKey: '',
            columns: [
                {key: 'selected', label: '선택', width: 50, hAlign: 'center'},
                {key: 'company_id', label: '회사ID', width: 120, hAlign: 'center', vAlign: 'center'},
                {key: 'company_name', label: '회사명', width: 200, tdClass: 'text-left td-truncate', vAlign: 'center'},
                {key: 'id', label: '보고서ID', width: 100, hAlign: 'center'},
                {key: 'mode', label: '평가유형', width: 80, hAlign: 'center'},
                {key: 'report_name', label: '리포트', width: 180, hAlign: 'center', tdClass: 'text-left td-truncate'},
                {key: 'time_stamp', label: '생성일', width: 160, hAlign: 'center'}, // width가 없으면 남은 공간 차지
                {key: 'confirmed', label: '확정여부', width: 80, hAlign: 'center'},
                {key: 'is_send_mail', label: '배포여부', width: 80, hAlign: 'center'},
            ],
            selectedRadios: {},

            globalReportOpt: {
                project_code: null,
                campaign_id: null,
                confirmed: null,
                report_mode: null,
                is_send_release_mail: false,
                //
                submit_lang: this.$i18n.locale,
            },

            loading: false,
            selected_num: 0,
            scrollbarWidth: 0,

            // 결과보고서 생성
            reportMode: 'full',
            pdf_filename: null,
            reportData: {
                info: null,
                benchmarks: null,
                parser: null,
                risk: null,
                scoring: null
            },

            // 결과보고서 변수 데이터
            map_api_result: {},
            fixed_selected_num: 0,
            report_target_company_id: null,
            
            // 결과보고서 다운로드 변수
            is_customize_name: false,
            customized_name: '{vendor_code}_{company_name}_{current_year}',
            isDownloading: false,
            downloadCancelled: false,
            downloadProgress: {
                current: 0,
                total: 0,
                text: ''
            },
        };
    },
    computed: {
        total_processed_count(){
            return Object.keys(this.map_api_result).length;
        },
        fail_company_list(){
            return Object.keys(this.map_api_result).filter(company_id => !this.map_api_result[company_id]);
        },
        progressPercent() {
            return this.fixed_selected_num ? ((this.total_processed_count / this.fixed_selected_num) * 100).toFixed(1) : 0;
        },
    },
    watch: {
        processedData: {
            handler() {
                this.updateVirtualScrollItems();  // 안전한 업데이트
            },
            deep: true
        }
    },
    async created() {
        this.globalReportOpt.project_code = this.$route.query.pc || this.$route.query.project_code;
        await this.searchHistory();
    },
    mounted() {
    },
    beforeDestroy() {
        if (this.updateTimer) {
            clearTimeout(this.updateTimer);  // 타이머 정리
        }
    },
    destroyed() {
    },
    methods: {
        expandAllCompanies() {
            this.expandedItems.clear();
            for (const company of this.processedData) {
                if (company.hasHistory) {
                    this.expandedItems.set(company.company_id, true);
                }
            }

            this.updateVirtualScrollItems();
        },
        collapseAllCompanies() {
            this.expandedItems.clear();
            this.updateVirtualScrollItems();
        },
        unselectRadio(item) {
            if (this.selectedRadios[item.company_id]) {
                this.$delete(this.selectedRadios, item.company_id);
            }
            else {
                this.$EventBus.$emit('toast-failure', '선택해제 실패', '항목을 선택해주세요.');
            }
        },
        unselectAllReports() {
            this.selectedRadios = {};
        },
        updateVirtualScrollItems() {
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }

            this.updateTimer = setTimeout(() => {
                this.virtualScrollItems = this.buildVirtualScrollItems();
            }, 16);
        },
        buildVirtualScrollItems() {
            const items = [];

            for (const company of this.processedData) {
                items.push({
                    ...company.companyData,
                    type: 'company',
                    uniqueKey: `company-${company.company_id}`,
                    hasHistory: company.hasHistory,
                    historyCount: company.historyCount,
                    expanded: this.expandedItems.has(company.company_id)
                });
                if (this.expandedItems.has(company.company_id) && company.history) {
                    for (let i = 0; i < company.history.length; i++) {
                        const historyItem = company.history[i];
                        items.push({
                            ...historyItem,
                            type: 'history',
                            uniqueKey: `history-${company.company_id}-${historyItem.id}`,
                            company_id: company.company_id,
                            company_name: company.company_name
                        });
                    }
                }
            }

            return items;
        },
        toggleExpand(companyId) {
            if (this.expandedItems.has(companyId)) {
                this.expandedItems.delete(companyId);
            } else {
                this.expandedItems.set(companyId, true);
            }
            this.updateVirtualScrollItems();
        },
        invalidateCache() {
            this.virtualScrollItemsCache = null;
            this.cacheKey = '';
        },
        preprocessData(rawData) {
            const processedMap = new Map();

            for (const item of rawData) {
                const companyId = item.company_id;

                if (item.deleted_at) {
                    continue;
                }

                if (!processedMap.has(companyId)) {
                    processedMap.set(companyId, {
                        company_id: companyId,
                        company_name: item.company_name,
                        history: [],
                        hasHistory: false,
                        historyCount: 0,
                        companyData: null // 회사 행에 표시될 대표 데이터
                    });
                }

                processedMap.get(companyId).history.push(item);
            }

            const result = [];
            for (const company of processedMap.values()) {
                company.history.sort((a, b) => dayjs(b.time_stamp).diff(dayjs(a.time_stamp)));

                company.hasHistory = company.history.length > 0;
                company.historyCount = company.history.length;

                if (company.hasHistory) {
                    const latestHistory = company.history[0];
                    company.companyData = {
                        company_id: company.company_id,
                        company_name: company.company_name,
                        id: latestHistory.id,
                        mode: latestHistory.mode,
                        report_name: latestHistory.report_name,
                        time_stamp: latestHistory.time_stamp,
                        confirmed: latestHistory.confirmed,
                        vendor_code: latestHistory.vendor_code
                    };
                } else {
                    company.companyData = {
                        company_id: company.company_id,
                        company_name: company.company_name
                    };
                }

                result.push(company);
            }

            return result;
        },

        async searchHistory() {
            try {
                this.loading = true;
                this.processedData = [];
                this.invalidateCache();

                const response = await this.$axios('/report/history', {
                    params: {
                        project_code: this.globalReportOpt.project_code,
                        mode: this.globalReportOpt.report_mode,
                        confirmed: this.globalReportOpt.confirmed,
                        with_alt: true,
                        with_deleted: false,
                    }
                });

                // 데이터 전처리
                this.processedData = this.preprocessData(response.data.result);
                this.expandAllCompanies();

            } catch (e) {
                console.error('searchHistory error:', e);
            } finally {
                this.loading = false;
            }
        },
        getLastThStyle(field) {
            const baseStyle = this.getColumnStyle(field);
            if (this.scrollbarWidth > 0 && baseStyle.width) {
                baseStyle.width = `calc(${baseStyle.width} + ${this.scrollbarWidth}px)`;
            } else if (this.scrollbarWidth > 0 && !baseStyle.width) {
                baseStyle.width = `${this.scrollbarWidth}px`;
            }
            return baseStyle;
        },
        getColumnStyle(field) {
            const style = {};
            if (field.width) {
                style.width = typeof field.width === 'number' ? `${field.width}px` : field.width;
            }
            if (field.hAlign) style.textAlign = field.hAlign;
            if (field.vAlign) style.verticalAlign = field.vAlign === 'center' ? 'middle' : field.vAlign;
            return style;
        },
        getThClass(field) {
            return field.thClass || '';
        },
        getTdClass(field) {
            return field.tdClass || '';
        },
        updateLang(lang, key) {
            this.globalReportOpt[key] = lang;
        },
        selectConfirmedReport() {
            const newSelection = {};

            for (const company of this.processedData) {
                // confirmed: true인 항목 중 가장 최신 것 선택
                const confirmedHistory = company.history
                    .filter(h => h.confirmed === true)
                    .sort((a, b) => dayjs(b.time_stamp).diff(dayjs(a.time_stamp)))[0];

                if (confirmedHistory) {
                    newSelection[company.company_id] = confirmedHistory.id;
                }
            }

            this.selectedRadios = {...newSelection};
        },
        selectLatestReport() {
            const newSelection = {};

            for (const company of this.processedData) {
                if (company.history && company.history.length > 0) {
                    const latestHistory = company.history[0];
                    newSelection[company.company_id] = latestHistory.id;
                }
            }

            this.selectedRadios = {...newSelection};
        },
        async handlingReport(type) {
            const totalLen = Object.keys(this.selectedRadios).length;

            if(totalLen === 0) {
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: '선택된 보고서가 없습니다.',
                    message: '처리할 보고서를 선택해주세요.'
                });
                this.loading = false;
                return;
            }
            
            const full_time_begin = performance.now();
            console.log('~ ConfirmBulkReport ~ ');
            console.log(' ~ full_time_begin => ', (full_time_begin / 1000));
            
            let confirmedCnt = 0;
            let unconfirmedCnt = 0;
            let excludedCnt = 0;
            let processedCnt = 0; // 실제 처리된 보고서 개수
            this.loading = true;
            this.map_api_result = {};

            const apiList = [];
            const map_api_result = {};
            const excludedReports = [];
            const processedCompanies = new Set(); // API 호출할 회사 ID 추적
            
            for (const [company_id, history_id] of Object.entries(this.selectedRadios)) {
                const targetCompany = this.processedData.find(c => Number(c.company_id) === Number(company_id));
                const targetHistory = targetCompany.history.find(h => Number(h.id) === Number(history_id));
                const confirmedHistory = targetCompany.history.find(h => h.confirmed);
                
                if(type === 'confirm'){
                    // 상태 카운트
                    if (targetHistory.confirmed) {
                        confirmedCnt++;
                        excludedCnt++;
                        excludedReports.push({
                            company_name: targetCompany.company_name,
                            period: targetHistory.period,
                            reason: '이미 확정됨'
                        });
                    } else {
                        unconfirmedCnt++;
                        processedCnt++; // 실제 처리됨
                        processedCompanies.add(company_id); // API 호출 대상 추가
                    }
                    
                    // API 호출 목록 (기존 확정 이력 삭제)
                    if (confirmedHistory?.id && confirmedHistory.id !== targetHistory.id) {
                        apiList.push({
                            api: () => this.$axios({
                                method: 'DELETE',
                                url: '/report/confirm',
                                data: {report_id: confirmedHistory?.id}
                            }),
                            company_id
                        });
                    }

                    // API 호출 목록 (신규 확정)
                    if (!targetHistory.confirmed) {
                        apiList.push({
                            api: () => this.$axios({
                                method: 'PUT',
                                url: '/report/confirm',
                                data: {report_id: targetHistory.id}
                            }),
                            company_id
                        });
                    }
                }
                
                if(type === 'cancel'){
                    // 상태 카운트
                    if (targetHistory.confirmed) {
                        confirmedCnt++;
                        processedCnt++; // 실제 처리됨
                        processedCompanies.add(company_id); // API 호출 대상 추가
                    } else {
                        unconfirmedCnt++;
                        excludedCnt++;
                        excludedReports.push({
                            company_name: targetCompany.company_name,
                            period: targetHistory.period,
                            reason: '이미 미확정 상태'
                        });
                    }
                    
                    // API 호출 목록 (확정 취소)
                    if(targetHistory.confirmed){
                        apiList.push({
                            api: () => this.$axios({
                                method: 'DELETE',
                                url: '/report/confirm',
                                data: {report_id: targetHistory?.id}
                            }),
                            company_id
                        });
                    }
                }
                
                if(type === 'delete'){
                    if (targetHistory.confirmed) {
                        confirmedCnt++;
                        excludedCnt++;
                        excludedReports.push({
                            company_name: targetCompany.company_name,
                            period: targetHistory.period,
                            reason: '확정된 보고서 (먼저 확정 취소 후 삭제해주세요)'
                        });
                    } else {
                        unconfirmedCnt++;
                        processedCnt++; // 실제 처리됨
                        processedCompanies.add(company_id); // API 호출 대상 추가
                    }
                    
                    if (!targetHistory.confirmed) {
                        apiList.push({
                            api: () => this.$axios({
                                method: 'DELETE',
                                url: '/report/history',
                                params: {id: targetHistory.id}
                            }),
                            company_id
                        });
                    }
                }
            }
            
            // API 호출할 회사만 map_api_result에 초기화
            processedCompanies.forEach(company_id => {
                map_api_result[company_id] = null;
            });
            
            this.map_api_result = map_api_result;

            // 제외된 항목이 있는 경우 알림
            if (excludedCnt > 0) {
                const h = this.$createElement;
                const excludedElements = [];
                
                excludedElements.push(h('div', {}, 
                    `다음 ${excludedCnt}개의 보고서는 제외됩니다:`));
                excludedElements.push(h('div', { style: 'margin-top: 8px;' }));
                
                excludedReports.forEach(r => {
                    excludedElements.push(h('div', { style: 'margin-left: 8px; margin-top: 4px;' }, 
                        `• ${r.company_name} (${r.period}) - ${r.reason}`));
                });
                
                excludedElements.push(h('div', { style: 'margin-top: 16px;' }, 
                    '계속 진행하시겠습니까?'));
                
                const proceed = await this.$showModal({
                    type: 'confirm',
                    state: 'warning',
                    title: '일부 보고서 제외',
                    message: h('div', {}, excludedElements)
                });

                if (!proceed) {
                    this.loading = false;
                    return;
                }
            }

            // API 호출 대상이 없는 경우
            if (apiList.length === 0) {
                const h = this.$createElement;
                let noTargetMessage = '처리 대상이 없습니다.';
                
                if (type === 'confirm') {
                    noTargetMessage = '선택된 보고서가 모두 이미 확정되었습니다.';
                } else if (type === 'cancel') {
                    noTargetMessage = '선택된 보고서가 모두 이미 미확정 상태입니다.';
                } else if (type === 'delete') {
                    noTargetMessage = '선택된 보고서가 모두 확정되어 삭제할 수 없습니다.';
                }
                
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: '처리 대상 없음',
                    message: h('div', {}, noTargetMessage)
                });
                this.loading = false;
                return;
            }

            this.fixed_selected_num = Object.keys(this.map_api_result).length;
                         
            for (let i = 0; i < apiList.length; i++) {
                const {api, company_id} = apiList[i];
                this.report_target_company_id = company_id;
                
                try {
                    const res = await api();
                    map_api_result[company_id] = true;
                    console.log('           ~ Confirm ResData => ', res.data);
                }
                catch (e) {
                    map_api_result[company_id] = false;
                }
                finally {
                    await waitTime(1500);
                    this.report_target_company_id = null;
                }
            }

            const full_time_end = performance.now();
            const total_time = full_time_end - full_time_begin;
            const h = this.$createElement;
            
            // 완료 메시지 구성 (VNode 사용)
            const messageElements = [];
            
            // 핸들링 타입 및 소요시간
            let typeLabel = type;
            if (type === 'confirm') typeLabel = '확정';
            else if (type === 'cancel') typeLabel = '확정 취소';
            else if (type === 'delete') typeLabel = '삭제';
            
            messageElements.push(h('div', {}, `핸들링 타입: ${typeLabel}`));
            messageElements.push(h('div', {}, `소요시간: ${this.formatSpendTime(total_time)}`));
            
            // 실패한 보고서 정보 추가 (API 호출 실패)
            const failedCnt = this.fail_company_list.length;
            if (failedCnt > 0) {
                messageElements.push(h('div', { style: 'margin-top: 16px; font-weight: 600; color: #dc3545;' }, 
                    `[실패한 보고서: ${failedCnt}개]`));
                
                this.fail_company_list.forEach(company_id => {
                    const targetCompany = this.processedData.find(c => Number(c.company_id) === Number(company_id));
                    if (targetCompany) {
                        messageElements.push(h('div', { style: 'margin-left: 8px; margin-top: 4px; color: #dc3545;' }, 
                            `• ${targetCompany.company_name}`));
                    }
                });
            }
            
            // 제외된 보고서 정보 추가
            if (excludedCnt > 0) {
                messageElements.push(h('div', { style: 'margin-top: 16px; font-weight: 600;' }, 
                    `[제외된 보고서: ${excludedCnt}개]`));
                
                excludedReports.forEach(r => {
                    messageElements.push(h('div', { style: 'margin-left: 8px; margin-top: 4px;' }, 
                        `• ${r.company_name} (${r.period}) - ${r.reason}`));
                });
            }
            
            // 실제 처리된 보고서 개수 정보 추가
            if (excludedCnt > 0 || processedCnt > 0 || failedCnt > 0) {
                messageElements.push(h('div', { style: 'margin-top: 16px; font-weight: 600;' }, 
                    `처리 완료: ${processedCnt}개`));
            }
            
            // 성공/실패 상태 및 타이틀 결정
            const msg = {
                state: 'success',
                title: '결과보고서 벌크 핸들링 완료',
            };
            if (failedCnt > 0) {
                msg.state = 'warning';
                msg.title = '결과보고서 벌크 핸들링 실패';
            }

            this.$showModal({
                type: 'alert',
                state: msg.state,
                title: msg.title,
                message: h('div', {}, messageElements)
            })
                .then(async ()=>{
                    await this.searchHistory();
                    this.selectedRadios = {};
                    this.loading = false;
                });

        },
        async submitReport() {
            const totalLen = Object.keys(this.selectedRadios).length;

            if(totalLen === 0) {
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: '선택된 보고서가 없습니다.',
                    message: '처리할 보고서를 선택해주세요.'
                });
                this.loading = false;
                return;
            }
            
            
            console.log('~ submitReport ~ ');

            let confirmedCnt = 0;
            let sendMailCnt = 0;
            let _accumulated_ele_replacement_time = 0;
            const _total_replacement_start_time = performance.now();
            console.log(`결과보고서 전송 시작시간: ${this.formatSpendTime(_total_replacement_start_time)}`);

            this.loading = true;
            this.map_api_result = {};

            const apiList = [];
            const excludedReports = [];
            

            for (const [company_id, history_id] of Object.entries(this.selectedRadios)) {
                const targetCompany = this.processedData.find(c => Number(c.company_id) === Number(company_id));
                const targetHistory = targetCompany.history.find(h => Number(h.id) === Number(history_id));

                // confirmed 및 is_send_mail 카운트
                if (targetHistory.confirmed) {
                    confirmedCnt++;
                }
                if (targetHistory.is_send_mail) {
                    sendMailCnt++;
                    excludedReports.push({
                        company_name: targetCompany.company_name,
                        period: targetHistory.period
                    });
                }

                // API 호출 대상 (confirmed이고 is_send_mail이 false인 경우만)
                if(targetHistory.confirmed && !targetHistory.is_send_mail) {
                    apiList.push({
                        api: () => this.$axios.post('/report/submit', {
                            project_code : targetHistory.priority ? targetHistory.priority.project_code : targetHistory.project_code,
                            campaign_id : targetHistory.priority ? targetHistory.priority.campaign_id : targetHistory.campaign_id,
                            company_id : targetHistory.priority ? targetHistory.priority.company_id : targetHistory.company_id,
                            history_id : targetHistory.priority ? targetHistory.priority.id : targetHistory.id,
                            period: targetHistory.period,
                            lang: this.globalReportOpt.submit_lang
                        }),
                        company_id
                    });
                }
            }

            // confirmed 개수와 선택 개수가 다른 경우
            if (confirmedCnt !== totalLen) {
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: '결과보고서 배포 실패',
                    message: `선택된 보고서 중 확정되지 않은 보고서가 있습니다.\n확정된 보고서: ${confirmedCnt}개 / 선택된 보고서: ${totalLen}개`,
                });
                this.loading = false;
                return;
            }

            // is_send_mail이 true인 항목이 있는 경우 알림
            if (sendMailCnt > 0) {
                const excludedList = excludedReports
                    .map(r => `• ${r.company_name} (${r.period})`)
                    .join('\n');
                
                const proceed = await this.$showModal({
                    type: 'confirm',
                    state: 'warning',
                    title: '이미 배포된 보고서 제외',
                    message: `다음 ${sendMailCnt}개의 보고서는 이미 배포되어 제외됩니다:\n\n${excludedList}\n\n계속 진행하시겠습니까?`
                });

                if (!proceed) {
                    this.loading = false;
                    return;
                }
            }

            // API 호출 대상이 없는 경우
            if (apiList.length === 0) {
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: '배포 대상 없음',
                    message: '선택된 보고서가 모두 이미 배포되었습니다.',
                });
                this.loading = false;
                return;
            }

            this.fixed_selected_num = apiList.length;

            for (let i = 0; i < apiList.length; i++) {
                const {api, company_id} = apiList[i];
                this.report_target_company_id = company_id;
                const _ele_replacement_begin_time = performance.now(); // 작업 시작 전 시간 기록

                try {
                    const {data} = await api();
                    this.$set(this.map_api_result, company_id, true);
                    console.log('           ~ Confirm ResData => ', data);
                }
                catch (e) {
                    this.$set(this.map_api_result, company_id, false);
                }
                finally {
                    this.report_target_company_id = null;

                    const _ele_replacement_end_time = performance.now(); // 작업 시작 전 시간 기록
                    const _ele_replacement_replacement_time = _ele_replacement_end_time - _ele_replacement_begin_time;
                    _accumulated_ele_replacement_time += _ele_replacement_replacement_time;
                    console.log(`      ~ 결과보고서 전송 종료시간: ${this.formatSpendTime(_ele_replacement_end_time)}`);
                    console.log(`        ~ 결과보고서 전송 소요시간: ${this.formatSpendTime(_ele_replacement_replacement_time)}`);
                    console.log(`   ~ 결과보고서 전송 누적 소요시간: ${this.formatSpendTime(_accumulated_ele_replacement_time)}`);
                    await this.sendMailBufferTiming();
                    
                    await waitTime(1000 * 10);
                }
            }

            const _total_replacement_end_time = performance.now();
            const total_time = _total_replacement_end_time - _total_replacement_start_time;
            console.log(`총 전송 종료시간: ${this.formatSpendTime(_total_replacement_end_time)}`);
            console.log(`총 전송 소요시간: ${this.formatSpendTime(total_time)}`);

            // 메시지 구성 (VNode 사용)
            const h = this.$createElement;
            const messageElements = [];
            
            // 소요시간
            messageElements.push(h('div', {}, `소요시간: ${this.formatSpendTime(total_time)}`));
            
            // 실패한 보고서 정보 추가 (API 호출 실패)
            const failedCnt = this.fail_company_list.length;
            if (failedCnt > 0) {
                messageElements.push(h('div', { style: 'margin-top: 16px; font-weight: 600; color: #dc3545;' }, 
                    `[실패한 보고서: ${failedCnt}개]`));
                
                this.fail_company_list.forEach(company_id => {
                    const targetCompany = this.processedData.find(c => Number(c.company_id) === Number(company_id));
                    if (targetCompany) {
                        messageElements.push(h('div', { style: 'margin-left: 8px; margin-top: 4px; color: #dc3545;' }, 
                            `• ${targetCompany.company_name}`));
                    }
                });
            }
            
            // 제외된 보고서 정보 추가
            if (sendMailCnt > 0) {
                messageElements.push(h('div', { style: 'margin-top: 16px; font-weight: 600;' }, 
                    `[제외된 보고서 - 이미 배포됨: ${sendMailCnt}개]`));
                
                excludedReports.forEach(r => {
                    messageElements.push(h('div', { style: 'margin-left: 8px; margin-top: 4px;' }, 
                        `• ${r.company_name} (${r.period})`));
                });
            }
            
            // 실제 배포된 보고서 개수 정보 추가
            if (sendMailCnt > 0 || apiList.length > 0 || failedCnt > 0) {
                messageElements.push(h('div', { style: 'margin-top: 16px; font-weight: 600;' }, 
                    `배포 완료: ${apiList.length}개`));
            }
            
            // 성공/실패 상태 및 타이틀 결정
            const msg = {
                state: 'success',
                title: '결과보고서 벌크 전송 완료',
            };
            if (failedCnt > 0) {
                msg.state = 'warning';
                msg.title = '결과보고서 벌크 전송 실패';
            }

            this.$showModal({
                type: 'alert',
                state: msg.state,
                title: msg.title,
                message: h('div', {}, messageElements)
            })
                .then(async ()=>{
                    await this.searchHistory();
                    this.selectedRadios = {};
                    this.loading = false;
                });
        },
        sendMailBufferTiming() {
            const minTime = 5000; // 최소 5초 (2000 밀리초)
            const maxTime = 10000; // 최대 10초 (4000 밀리초)

            // 2초에서 4초 사이의 랜덤 시간을 생성
            const _random_buffer_time = Math.floor(Math.random() * (maxTime - minTime + 1)) + minTime;

            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(true);
                }, _random_buffer_time);
            });
        },
        formatTime(date) {
            return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
        },
        formatSpendTime(ms) {
            const milliseconds = ms % 1000;
            const seconds = Math.floor((ms / 1000) % 60);
            const minutes = Math.floor((ms / (1000 * 60)) % 60);
            const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);

            return `${hours ? hours + 'h ' : ''}${minutes ? minutes + 'm ' : ''}${seconds ? seconds + 's ' : ''}${milliseconds.toFixed(3)}ms`;
        },
        async viewReport(_report) {
            const _res_report_block = await axios.get(`https://${process.env.VUE_APP_S3_BUCKET_NAME}.s3.${process.env.VUE_APP_S3_REGION_NAME}.amazonaws.com/${_report.report_path}`, {
                responseType: 'blob'
            });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([_res_report_block.data], {type: 'application/pdf'}));
            link.setAttribute('download', _report.report_name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async downloadReport() {
            const selectedCount = Object.keys(this.selectedRadios).length;
            if (selectedCount === 0) {
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: '선택된 보고서 없음',
                    message: '다운로드할 보고서를 선택해주세요.'
                });
                return;
            }
            
            // 다운로드 설정 모달 열기
            this.$bvModal.show('download-setting-modal');
        },
        
        closeDownloadSettingModal() {
            this.$bvModal.hide('download-setting-modal');
        },
        
        onDownloadModalHidden() {
            if (this.isDownloading) {
                this.cancelDownload();
            }
            this.resetDownloadState();
        },
        
        cancelDownload() {
            this.downloadCancelled = true;
            this.resetDownloadState();
        },
        
        resetDownloadState() {
            this.isDownloading = false;
            this.downloadCancelled = false;
            this.downloadProgress = {
                current: 0,
                total: 0,
                text: ''
            };
        },
        
        generateFileName(report, company) {
            if (!this.is_customize_name) {
                // 원본 파일명 사용
                return report.report_name || `report_${company.company_id}.pdf`;
            }
            
            // 커스텀 파일명 생성
            const currentYear = new Date().getFullYear().toString();
            let fileName = this.customized_name || '{vendor_code}_{company_name}_{current_year}';
            
            fileName = fileName
                .replace(/{vendor_code}/g, company.companyData.vendor_code || '')
                .replace(/{company_name}/g, company.company_name || '')
                .replace(/{project_code}/g, this.globalReportOpt.project_code || '')
                .replace(/{report_mode}/g, report.mode || company.mode || '')
                .replace(/{current_year}/g, currentYear);
            
            // 파일 확장자 추가
            if (!fileName.endsWith('.pdf')) {
                fileName += '.pdf';
            }
            
            // 파일명에 사용할 수 없는 문자 제거
            fileName = fileName.replace(/[\\/:*?"<>|]/g, '_');
            
            return fileName;
        },
        
        async startDownloadReports() {
            const selectedKeys = Object.keys(this.selectedRadios);
            if (selectedKeys.length === 0) {
                return;
            }
            
            this.isDownloading = true;
            this.downloadCancelled = false;
            this.downloadProgress = {
                current: 0,
                total: selectedKeys.length,
                text: '다운로드 준비 중...'
            };
            
            try {
                const zipFiles = {};
                const usedFilenames = new Set();
                
                for (let i = 0; i < selectedKeys.length; i++) {
                    if (this.downloadCancelled) {
                        break;
                    }
                    
                    const companyId = selectedKeys[i];
                    const company = this.processedData.find(c => String(c.company_id) === String(companyId));
                    
                    if (!company) continue;
                    
                    const historyId = this.selectedRadios[companyId];
                    const report = company.history?.find(h => String(h.id) === String(historyId));
                    
                    if (!report || !report.report_path) continue;
                    
                    this.downloadProgress.current = i;
                    this.downloadProgress.text = `${company.company_name} 다운로드 중... (${i + 1}/${selectedKeys.length})`;
                    
                    try {
                        const reportUrl = `https://${process.env.VUE_APP_S3_BUCKET_NAME}.s3.${process.env.VUE_APP_S3_REGION_NAME}.amazonaws.com/${report.report_path}`;
                        const response = await axios.get(reportUrl, { responseType: 'arraybuffer' });
                        
                        // 파일명 생성
                        let fileName = this.generateFileName(report, company);
                        
                        // 중복 파일명 처리
                        if (usedFilenames.has(fileName)) {
                            const lastDotIndex = fileName.lastIndexOf('.');
                            if (lastDotIndex > 0) {
                                const name = fileName.substring(0, lastDotIndex);
                                const ext = fileName.substring(lastDotIndex);
                                fileName = `${name}_${companyId}${ext}`;
                            } else {
                                fileName = `${fileName}_${companyId}`;
                            }
                        }
                        usedFilenames.add(fileName);
                        
                        zipFiles[fileName] = new Uint8Array(response.data);
                        
                        // UI 블로킹 방지를 위한 짧은 대기
                        await waitTime(500);
                    } catch (error) {
                        console.error(`Failed to download report for ${company.company_name}:`, error);
                    }
                }
                
                if (this.downloadCancelled) {
                    this.resetDownloadState();
                    return;
                }
                
                if (Object.keys(zipFiles).length === 0) {
                    this.$showModal({
                        type: 'alert',
                        state: 'warning',
                        title: '다운로드 실패',
                        message: '다운로드할 수 있는 보고서가 없습니다.'
                    });
                    this.resetDownloadState();
                    return;
                }
                
                this.downloadProgress.text = 'ZIP 파일 생성 중...';
                this.downloadProgress.current = selectedKeys.length;
                
                // ZIP 파일 생성
                const zipped = zipSync(zipFiles, { level: 6 });
                const blob = new Blob([zipped], { type: 'application/zip' });
                
                // 타임스탬프 생성
                const timestamp = dayjs().format('YYYYMMDDHHmmss');
                const zipFilename = `result_report_${timestamp}.zip`;
                
                // 다운로드 링크 생성
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = zipFilename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);
                
                this.$showModal({
                    type: 'alert',
                    state: 'success',
                    title: '다운로드 완료',
                    message: `${Object.keys(zipFiles).length}개의 보고서가 포함된 ZIP 파일이 다운로드되었습니다.`
                });
                
                this.closeDownloadSettingModal();
            } catch (error) {
                console.error('Download error:', error);
                this.$showModal({
                    type: 'alert',
                    state: 'danger',
                    title: '다운로드 오류',
                    message: 'ZIP 파일 생성 중 오류가 발생했습니다.'
                });
            } finally {
                this.resetDownloadState();
            }
        }
    }

};
</script>

<style lang="scss" scoped>
.virtual-table-wrapper {
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    overflow: hidden;

    .header-container {
        background-color: #f8f9fa;
    }

    .body-scroll-container {
        height: 50vh;
        overflow-y: auto;
    }

    .table, table {
        table-layout: fixed;
        width: 100%;
        margin-bottom: 0;
    }

    td {
        padding: 0.75rem;
    }

    .header-container th {
        padding: 0.75rem;
        vertical-align: middle;
        border: none;
        font-weight: 600;
        color: #495057;
    }

    .body-table {
        border-collapse: collapse;
    }

    .body-row {
        border-bottom: 1px solid #dee2e6;

        &:hover {
            background-color: #f5f5f5;
        }

        &.company-row {
            background-color: #ffffff;
            font-weight: 500;

            &.expandable {
                &:hover {
                    background-color: #e9ecef;
                }
            }
        }

        &.history-row {
            background-color: #f8f9fa;

            &:hover {
                background-color: #e9ecef;
            }
        }
    }

    .td {
        padding: 0.75rem;
        vertical-align: middle;
        background-color: white;
    }

    .td-truncate {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .company-name-cell {
        display: flex;
        align-items: center;
        gap: 8px;

        .expand-icon {
            font-size: 12px;
            color: #6c757d;
            transition: transform 0.2s ease;
            width: 12px;
        }
    }

    .history-cell {
        background-color: #f8f9fa !important;
    }

    .history-indent {
        padding-left: 24px;
        font-size: 0.9em;
        color: #6c757d;
    }
}

.empty-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50vh;
    padding: 2rem;
    color: #6c757d;
    font-style: italic;
}
</style>
